import {
  Padding,
  padding,
  spacing,
  styled,
  Text,
  TextStyling,
} from '@thg-commerce/gravity-theme'

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.palette.greys.lighter};
`

export const MessageText = styled.p<{
  textStyling?: TextStyling
}>`
  ${(props) =>
    props.textStyling?.entry &&
    props.textStyling?.style &&
    Text(props.textStyling.entry, props.textStyling.style)}
  ${(props) => props.textStyling?.textColor && `color: ${props.textStyling.textColor};`}
`

export const ClosedContainer = styled.div<{
  isOpen: boolean
  qualifiedWhenClosed: boolean
}>`
  padding: ${spacing(1)} ${spacing(2)};

  display: ${(props) =>
    props.isOpen ? 'none' : props.qualifiedWhenClosed ? 'flex' : 'block'};
  justify-content: ${(props) =>
    props.qualifiedWhenClosed ? 'space-between' : 'flex-start'};
`

const defaultContentContainerPadding: Padding = {
  top: 0,
  right: 2,
  bottom: 2,
  left: 2,
}

export const ContentContainer = styled.div<{
  contentContainerPadding?: Padding
}>`
  ${(props) => padding(props.contentContainerPadding || defaultContentContainerPadding)}
`
